import { useTranslation } from 'react-i18next';

import { ReactComponent as ZoomInIcon } from '../assets/icons/ZoomInIcon.svg';
import { ReactComponent as ZoomOutIcon } from '../assets/icons/ZoomOutIcon.svg';
import { ReactComponent as ZoomResetIcon } from '../assets/icons/ZoomResetIcon.svg';
import ButtonGroup from '../Button/ButtonGroup';
import IconButton from '../Button/IconButton';
import {
  DEFAULT_Y_SCALE_INFO_MAX,
  DEFAULT_Y_SCALE_INFO_MIN,
  DEFAULT_Y_SCALE_STEP,
} from './const';

interface VerticalZoomProps {
  range: [number, number];
  updateRange?: (range: [number, number]) => void;
  updateScale?: (ratio: number) => void;
  step?: number;
}

const VerticalZoom = ({
  range,
  updateRange,
  updateScale,
  step = DEFAULT_Y_SCALE_STEP,
}: VerticalZoomProps) => {
  const { t } = useTranslation();

  return (
    <ButtonGroup radius="none" className="editor-zoom editor-zoom-vertical">
      {/*
        ISSUE-060 — the names below follow the BEHAVIOUR, not the icon file
        name, and the sign convention is the OPPOSITE of HorizontalZoom's.
        `updateScale` is Editor's `updateYScale`, which multiplies the
        AMPLITUDE RANGE by the ratio: a smaller range drawn over the same pixel
        height makes the waveform bigger, so a ratio below 1 zooms IN.
      */}
      <IconButton
        aria-label={t('Zoom in vertically') as string}
        onClick={() => updateScale?.(1 - step)}
        disabled={
          range[0] === DEFAULT_Y_SCALE_INFO_MIN[0] &&
          range[1] === DEFAULT_Y_SCALE_INFO_MIN[1]
        }
      >
        <ZoomInIcon />
      </IconButton>
      <IconButton
        aria-label={t('Reset vertical zoom') as string}
        onClick={() => updateRange?.(DEFAULT_Y_SCALE_INFO_MAX)}
        disabled={
          range[0] === DEFAULT_Y_SCALE_INFO_MAX[0] &&
          range[1] === DEFAULT_Y_SCALE_INFO_MAX[1]
        }
      >
        <ZoomResetIcon />
      </IconButton>
      <IconButton
        aria-label={t('Zoom out vertically') as string}
        onClick={() => updateScale?.(1 + step)}
        disabled={
          range[0] === DEFAULT_Y_SCALE_INFO_MAX[0] &&
          range[1] === DEFAULT_Y_SCALE_INFO_MAX[1]
        }
      >
        <ZoomOutIcon />
      </IconButton>
    </ButtonGroup>
  );
};

export default VerticalZoom;
